export default {
ListaDePrecios:{
    idPrestador: '5e1dd57aa5d71aff61a61341',
    fechaAlta: '04-05-2020',
    fechaFin: '',
    precios:[
    ]
},


planes: [{"idPlan":"","nombre":"410","fechaDeCreacion":"","vigente":false,"versiones":[{"IdPlanVersion":1,"nombre":"diciembre 2019","fechainicio":"","fechafin":"","prestaciones":[{"_id":6,"nombre":"Servicio de cremación tradicional comunitaria","esgrupo":false,"reglas":[{"id":1,"prioridad":1,"tipo":"vigencia","nombre":"vigencia","tituloPersonalizado":"","cantidad":"6","unidadMedida1":"consultas","unidadMedida2":2,"porMascota":true,"porMascotas":[{"id":0,"desde":0,"hasta":"Infinito","cantidad":"Infinito"}],"reglaHija":0,"PorPrestadores":[{"id":1,"cantidad":0},{"id":2,"cantidad":0}]}]},{"_id":8,"nombre":"Servicio de cremación individual con devolución de cenizas","esgrupo":false,"reglas":[{"id":1,"prioridad":1,"tipo":"descuento","nombre":"descuento","tituloPersonalizado":"50% de dto en servicio de cremación","cantidad":"","unidadMedida1":"consultas","unidadMedida2":2,"porMascota":true,"porMascotas":[{"id":0,"desde":0,"hasta":"Infinito","cantidad":"Infinito"}],"reglaHija":"2","PorPrestadores":[{"id":1,"cantidad":"25"},{"id":2,"cantidad":"25"}]},{"id":2,"prioridad":2,"tipo":"vigencia","nombre":"vigencia","tituloPersonalizado":"","cantidad":"6","unidadMedida1":"consultas","unidadMedida2":2,"porMascota":true,"porMascotas":[{"id":0,"desde":0,"hasta":"Infinito","cantidad":"Infinito"}],"reglaHija":0,"PorPrestadores":[{"id":1,"cantidad":0},{"id":2,"cantidad":0}]}]},{"esgrupo":false,"reglas":[{"id":1,"prioridad":1,"tipo":"topeDeUso","nombre":"Tope de Uso","tituloPersonalizado":"2 consultas sin cargo","cantidad":"2","unidadMedida1":"consultas","unidadMedida2":"mes","porMascota":true,"porMascotas":[{"id":0,"desde":0,"hasta":"Infinito","cantidad":"Infinito"}],"reglaHija":"2","PorPrestadores":[{"id":1,"cantidad":0},{"id":2,"cantidad":0}]},{"id":2,"prioridad":2,"tipo":"topeDeUso","nombre":"Tope de Uso","tituloPersonalizado":"tope de 12 anuales","cantidad":"12","unidadMedida1":"consultas","unidadMedida2":2,"porMascota":true,"porMascotas":[{"id":0,"desde":0,"hasta":"Infinito","cantidad":"Infinito"}],"reglaHija":0,"PorPrestadores":[{"id":1,"cantidad":0},{"id":2,"cantidad":0}]}],"nombre":"veterinario a domicilio","precio":"1000","_id":26},{"_id":10,"nombre":"Vacunación gratuita según calendario obligatorio","esgrupo":false,"reglas":[{"id":1,"prioridad":1,"tipo":"vigencia","nombre":"vigencia","tituloPersonalizado":"","cantidad":"2","unidadMedida1":"consultas","unidadMedida2":2,"porMascota":true,"porMascotas":[{"id":0,"desde":0,"hasta":"Infinito","cantidad":"Infinito"}],"reglaHija":0,"PorPrestadores":[{"id":1,"cantidad":0},{"id":2,"cantidad":0}]}]},{"_id":24,"nombre":"Internación","esgrupo":false,"reglas":[{"id":1,"prioridad":1,"tipo":"descuento","nombre":"descuento","tituloPersonalizado":"","cantidad":"","unidadMedida1":"consultas","unidadMedida2":2,"porMascota":true,"porMascotas":[{"id":0,"desde":0,"hasta":"Infinito","cantidad":"Infinito"}],"reglaHija":"2","PorPrestadores":[{"id":1,"cantidad":"25"},{"id":2,"cantidad":"25"}]},{"id":2,"prioridad":2,"tipo":"topeDeUso","nombre":"Tope de Uso","tituloPersonalizado":"límite de 4 días al año por mascota","cantidad":"4","unidadMedida1":"dia","unidadMedida2":"ano","porMascota":true,"porMascotas":[{"id":0,"desde":0,"hasta":"Infinito","cantidad":"Infinito"}],"reglaHija":"3","PorPrestadores":[{"id":1,"cantidad":0},{"id":2,"cantidad":0}]},{"id":3,"prioridad":3,"tipo":"vigencia","nombre":"vigencia","tituloPersonalizado":"","cantidad":"6","unidadMedida1":"consultas","unidadMedida2":2,"porMascota":true,"porMascotas":[{"id":0,"desde":0,"hasta":"Infinito","cantidad":"Infinito"}],"reglaHija":0,"PorPrestadores":[{"id":1,"cantidad":0},{"id":2,"cantidad":0}]}]}]}]}],

versiones: [],

prestaciones: [
      {
          "_id": 1,
          "nombre": "Comidas para Perros",
          "esgrupo": true,
          "PrestacionesHijas": [
          ],
      },
      {
        "_id": 2,
        "nombre": "Etología caninca",
        "esgrupo": true,
        "PrestacionesHijas": [           
        ],
    },
    {
        "_id": 3,
        "nombre": "Guardería y paseadores",
        "esgrupo": true,
        "PrestacionesHijas": [ 
        ],
    },
    {
        "_id": 4,
        "nombre": "Consulta de urgencia / emergencia",
        "esgrupo": false,
    },
    {
        "_id": 5,
        "nombre": "Servicio de cremación",
        "esgrupo": true,
        "PrestacionesHijas": [      
            {"_id": 6, "nombre": "Servicio de cremación tradicional comunitaria",  "esgrupo": "false", "reglas": []},
            {"_id": 8, "nombre": "Servicio de cremación individual con devolución de cenizas", "esgrupo": false, "reglas": []},     
        ],
    },
    {
        "_id": 6,
        "nombre": "Servicio de cremación tradicional comunitaria",       
        "esgrupo": false,
    },
    {
        "_id": 7,
        "nombre": "dto. en alimento",
        "esgrupo": false,
    },
    {
        "_id": 8,
        "nombre": "Servicio de cremación individual con devolución de cenizas",
        "esgrupo": false,
    },
    {
        "_id": 9,
        "nombre": "dto. en medicamentos y vacunas",
        "esgrupo": false,
    }, 
    {
        "_id": 10,
        "nombre": "Vacunación gratuita según calendario obligatorio",
        "esgrupo": false,
    },  
    {
        "_id": 11,
        "nombre": "RX/EX/EXG",
        "esgrupo": false,
    },  
    {
        "_id": 12,
        "nombre": "Sanatorio integral Veterinario",
        "esgrupo": false,
    },
    {
        "_id": 13,
        "nombre": "cirugías",
        "esgrupo": false,
    },
    {
        "_id": 14,
        "nombre": "urgencia y emergencia",
        "esgrupo": false,
    },
    {
        "_id": 15,
        "nombre": "aplicaciones",
        "esgrupo": false,
    },
    {
        "_id": 16,
        "nombre": "Vacunación calendario anual obligatorio sin cargo",
        "esgrupo": false,
    },
    {
        "_id": 17,
        "nombre": "Vacunas no incluidas en calendario anual obligatorio",
        "esgrupo": false,
    },
    {
        "_id": 18,
        "nombre": "Resto de análisis cuando supere los sin cargo",
        "esgrupo": false,        
    },
    {
        "_id": 19,
        "nombre": "Adiestramiento y consulta por educación canina",
        "esgrupo": false,
    },
    {
        "_id": 20,
        "nombre": "Cursos brindados por el prestador",
        "esgrupo": false,
    },
    {
        "_id": 21,
        "nombre": "Guardería canina",
        "esgrupo": false,
    },
    {
        "_id": 22,
        "nombre": "Servicio de paseador de perros",
        "esgrupo": false,
    },
    {
        "_id": 23,
        "nombre": "Guardería familiar para perros",
        "esgrupo": false,
    },
    {
        "_id": 24,
        "nombre": "Internación",
        "esgrupo": false,        
    },
    {
        "_id": 25,
        "nombre": "Consulta normal",
        "esgrupo": false,
    },
    
],

reglas: [
    {
        "idRegla":'',
        "tipo": "descuento",
        "nombre": "Descuento",
        "tituloPersonalizado": "",
        "unidadMedida": "porcentaje",
        "porMascota":true,
        "cantidad": "",
        "porMascotas":[
            
        ],
        "CantPorPrestadores":[
            {"id":1, "cantidad":0},
            {"id":2, "cantidad":0},
        ],
        "ReglasHijas": []
    },
    {
        "idRegla":'',
        "tipo": "vigencia",
        "nombre": "Vigencia",
        "tituloPersonalizado": "",
        "cantidad": "",
        "unidadMedida1":"mes",
        "unidadMedida2":"ano", 
        "porMascota":true,
        "porMascotas":[
            {
                "desde": 0,
                "hasta": 1,
                "cantidad": 0,
            },
        ],       
        "ReglasHijas": [],
    },
    {
        "idRegla":'',
        "tipo": "topeDeUso",
        "nombre": "Tope de Uso",
        "tituloPersonalizado": "",
        "cantidad": "",
        "unidadMedida1":"consultas",
        "unidadMedida2":"ano",       
        "porMascota":true,
        "porMascotas": [
            {
                "desde": 0,
                "hasta": 1,
                "cantidad": 0,
            },
        ],
        "ReglasHijas": [],
    },
    {
        "idRegla":'',
        "tipo": "reglacompartida",
        "nombre": "Regla Compartida",
        "tituloPersonalizado": "",
        "cantidad": "",
        "unidadMedida1":"mes",
        "unidadMedida2":"ano", 
        "porMascota":true,
        "porMascotas":[
            {
                "desde": 0,
                "hasta": 1,
                "cantidad": 0,
            },
        ],       
        "ReglasHijas": [],
    },
    {
        "idRegla":'',
        "tipo": "leyenda",
        "nombre": "Leyenda",
        "tituloPersonalizado": "",
        "texto":"",
    },
    {
        "idRegla":'',
        "tipo": "rango",
        "nombre": "Rango",
        "tituloPersonalizado": "",
        "ReglasHijas": [],
    },
    {
        "idRegla":'',
        "tipo": "coseguro",
        "nombre": "Coseguro",
        "tituloPersonalizado": "",
        "ReglasHijas": [],
    },
],

unidadesDeMedida: [
    {"value":"consultas", "name":"consultas"},    
    {"value":"mes", "name":"mes"},
    {"value":"dia", "name":"dia"},
    {"value":"hora", "name":"hora"},
    {"value":"kg", "name":"kg"},
    {"value":"porcentaje", "name":"porcentaje"},
    {"value":"pesos", "name":"pesos"},
    {"value":"ano", "name":"año"},
    {"value":"fecha", "name":"fecha"}
],

Prestadores:[
    {"id":1, "nombre": "SiVet"},
    {"id":3, "nombre": "MasterCan"},
    {"id":4, "nombre": "Mascotas del Oeste"}
]
};


